import React, { useEffect, useState } from "react";
import Modal from "../../../components/UIComponents/CustomModal/Modal";
import { Checkbox } from "semantic-ui-react";
import { toast } from "react-toastify";
import "./SocialTokenScopeModal.scss";
import moment from "moment";

import InstagramLogin from "./InstagramLogin";
import FacebookLogin from "./FacebookLogin";
import { useDispatch } from "react-redux";
import { ALLOW_PAGE_SELECTION, NO_PAGE_SELECTION } from "../../../reducers/facebookPagesModalReducer";

const SocialTokenScopeModal = ({ onClose, open, platform, storeFbSocialToken, storeIgSocialToken, packageObj, ...props }) => {
    const [checkedState, setCheckedState] = useState(
        props.isSMRChecked ? [true, false, true, false] : props.isSMPChecked ? [false, false, true, false, true] : [false, false, true, false],
    );
    const [scope, setScope] = useState("");
    const [allowPageSelection, setAllowPageSelection] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (open) {
            setCheckedState(
                props.isSMRChecked
                    ? [true, false, true, false, true]
                    : props.isSMPChecked
                      ? [false, false, true, false, true]
                      : [false, false, true, false, false],
            );
            setScope("");
            setAllowPageSelection(false);
        }
        if (props.selectAll) {
            setCheckedState([true, true, true, true, true]);
            setAllowPageSelection(true);
        }
    }, [open]);

    useEffect(() => {
        let scope = ["public_profile"];
        let scopeString = "";

        checkedState.map((value, index) => {
            if (value && featureScope[platform.name]) {
                if (platform.name === "linkedin") scope.splice(0, 2, "r_liteprofile", "r_emailaddress");
                if (featureScope[platform.name][index] !== "") scope.push(featureScope[platform.name][index]);
            }
        });
        // if (allowPageSelection) scope.push("pages_show_list");

        scopeString = scope.join(",");
        // console.log("first", scopeString);

        const uniqueScopeString = [...new Set(scopeString.split(","))].join(",");

        setScope(uniqueScopeString);
    }, [checkedState, allowPageSelection]);


    useEffect(() => {
        if(allowPageSelection) {
            console.log("DIS in IF ")
            dispatch({type: ALLOW_PAGE_SELECTION})
        }
        else {
            console.log("DIS in ELSE")
            dispatch({type: NO_PAGE_SELECTION})
        }
    }, 
    [allowPageSelection])

    const permissions = ["Social Media Response", "Page Analytics", "Listening", "Dark Post", "Social Media Publishing"];

    const testCondition = (index) => {
        let render = true;
        // if (index === 0 && platform.name === "instagram") {
        //     render = false;
        // }
        if ([0, 4].includes(index) && platform.name === "linkedin") render = false;
        if (index === 1 && ["starter", "smb"].includes(packageObj.package_code)) {
            render = false;
        }

        return render;
    };

    const featureScope = {
        facebook: [
            "pages_messaging,pages_read_engagement,pages_read_user_content,pages_manage_metadata,pages_show_list,pages_manage_engagement,manage_pages,business_management",
            "read_insights,pages_show_list,manage_pages,business_management", // Required for pages management 
            "",
            "ads_management,pages_show_list,manage_pages,business_management",
            "pages_manage_posts,pages_read_engagement,manage_pages,pages_show_list,business_management",
        ],
        instagram: [
            "instagram_basic,instagram_manage_messages,pages_messaging,instagram_manage_comments,pages_manage_metadata,business_management",
            "instagram_manage_insights,pages_show_list,business_management",
            "pages_show_list,instagram_basic,pages_read_engagement,instagram_manage_comments,business_management", //listen
            "ads_management,pages_show_list",
            "instagram_basic,instagram_content_publish,pages_read_engagement",
        ],
        linkedin: [
            "", //smr
            // "r_liteprofile,r_emailaddress,w_member_social,rw_organization_admin,w_organization_social,r_organization_social,r_member_social,r_basicprofile",
            "r_organization_social", //opa
            "r_member_social,r_basicprofile", //listen
            "", //darkpost
            "rw_organization_admin,w_member_social,w_organization_social", //smp
        ],
    };

    const socialresponse = (response) => {
        if (response.accessToken) {
            if (platform.name === "facebook") return storeFbSocialToken(response);
            else if (platform.name === "instagram") return storeIgSocialToken(response);
        } else if (response.status === undefined) {
            toast.error("Error in Authorizing");
        } else if (response.status === "not_authorized") {
            toast.error("Error in Authorizing");
        } else {
            toast.error("Error in Authorizing");
        }
    };

    const onCancel = () => {
        setCheckedState([false, false, true, false]);
        onClose();
    };

    const handleOnChange = (position) => {
        const updatedCheckedState = checkedState.map((item, index) => (index === position ? !item : item));

        setCheckedState(updatedCheckedState);
    };

    const handleLinkedinAuthenticate = () => {
        // console.log("clickedd");
        if (platform.name === "linkedin") {
            // console.log("ccc", scope);
            const unique_identifier = moment.now();
            // const uri = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=81p4scwoytpfl7&redirect_uri=${window.location.origin}/social-tokens/oauth-callback&state=${unique_identifier},socialToken&scope=r_liteprofile,r_emailaddress,w_member_social,rw_organization_admin,w_organization_social,r_organization_social,r_member_social,r_basicprofile`;
            const uri = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&redirect_uri=${window.location.origin}/social-tokens/oauth-callback&state=${unique_identifier},socialToken&scope=${scope}`;
            window.location.href = uri;
            onClose();
        }
    };

    return (
        <Modal className="tkModal" show={open} onClose={onCancel}>
            <Modal.Header className="">Permissions</Modal.Header>
            <Modal.Content className="tkModalContent">
                <p className="tkModalHeader">
                    Please check the boxes for which you want to provide the permissions to Radarr to do the following for your social profiles.
                </p>
                <p className="tkModalHeader">Please Note: Different permission cannot be provided for different pages under the same account</p>

                {permissions.map((value, index) => {
                    return (
                        testCondition(index) && (
                            <>
                                <div
                                    key={index}
                                    className={`checkOptions ${platform.name === "facebook" && index === 2 ? "checkOptions-listening-facebook" : ""}`}>
                                    <label htmlFor={`custom-checkbox-${index}`}>{value}</label>

                                    {index === 2 ? (
                                        <Checkbox
                                            toggle
                                            readOnly
                                            id={`custom-checkbox-${index}`}
                                            name={value}
                                            value={value}
                                            checked={checkedState[index]}
                                            onChange={() => handleOnChange(index)}
                                        />
                                    ) : (
                                        <Checkbox
                                            toggle
                                            id={`custom-checkbox-${index}`}
                                            name={value}
                                            value={value}
                                            checked={checkedState[index]}
                                            onChange={() => handleOnChange(index)}
                                        />
                                    )}
                                </div>
                                {index === 2 && ["facebook", "linkedin"].includes(platform.name) && (
                                    <>
                                        <Checkbox
                                            id={`custom-checkbox-pages-${index}`}
                                            name={value}
                                            value={value}
                                            label="Allow page selection"
                                            checked={allowPageSelection}
                                            onChange={() => setAllowPageSelection(!allowPageSelection)}
                                        />
                                    </>
                                )}
                            </>
                        )
                    );
                })}
            </Modal.Content>
            <Modal.Actions>
                <div className="buttonsSection">
                    <div className="buttons">
                        <Modal.ActionButton
                            normal
                            onClick={() => {
                                onCancel();
                            }}>
                            Cancel
                        </Modal.ActionButton>
                        <Modal.ActionButton
                            filled
                            onClick={() => {
                                handleLinkedinAuthenticate();
                            }}>
                            {platform.name === "facebook" ? (
                                <FacebookLogin scope={scope} onCancel={onCancel} socialresponse={socialresponse} />
                            ) : platform.name === "instagram" ? (
                                <InstagramLogin scope={scope} onCancel={onCancel} socialresponse={socialresponse} />
                            ) : (
                                <p>Authenticate</p>
                            )}
                        </Modal.ActionButton>
                    </div>
                    {/* {isEmpty && <div className="errorNote">*Plese select a feature to continue</div>} */}
                </div>
            </Modal.Actions>
        </Modal>
    );
};

export default SocialTokenScopeModal;
